export default __webpack_public_path__ + "static/media/star.8070f233.svg";